<template lang="pug">
.video-card-wrap
  .img-wrap-vertical(:class="{'img-wrap-horizontal': type === 'horizontal'}")
    client-only
      img(v-lazy="img + (type === 'horizontal' ? horizontalFormat : verticalFormat)", :key='img', alt='loklok video cover')
    .shadow-layer(v-if='mark')
      span {{mark}}
  h3.title(v-if="title") {{title}}
</template>

<script>
export default {
  name: 'VideoCard',
  data() {
    return {
      horizontalFormat: '',
      verticalFormat: '?imageView2/1/w/380/h/532/format/webp/interlace/1/ignore-error/1/q/90!'
    }
  },
  props: {
    type: {
      type: String,
      // horizontal: 水平， vertical: 垂直
      default: 'vertical'
    },
    title: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    mark: {
      type: String | Number,
      default: ''
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../styles/index'
.video-card-wrap
  // width: 226px
  width: 100%
  .img-wrap-vertical
    position: relative
    // 266/190 = 1.4
    // padding-top: 140%
    padding-top: calc( 266 / 190 * 100% )
    border-radius: 8px
    background: $backgroundColor1
    overflow: hidden
    img
      width: 100%
      height: 100%
      border-radius: 8px
      display: block
      position: absolute
      left: 0
      top: 0
      user-select: none
    .shadow-layer
      position: absolute
      left: 0
      right: 0
      bottom: 0
      height: 34px
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)
      font-size: 12px
      color: $mainTextColor
      font-weight: bold
      letter-spacing: 0
      line-height: 34px
      text-shadow: 0 0 16px rgba(0,0,0,0.60)
      @include ellipsis
      ::before
        content: ' '
        display: block
        width: 4px
        height: 8px
        position: absolute
        background: #FF4343
        left: 0px
        bottom: 13px
        z-index: 1
      span
        padding-left: 12px
        user-select: none
  .img-wrap-horizontal
    // 166/295 * 100 =56.27%
    padding-top: calc( 166 / 295 * 100% )
    img
      width: 100%
      height: 100%
      border-radius: 8px
      display: block
      position: absolute
      left: 0
      top: 0
    .shadow-layer
      position: absolute
      left: 0
      right: 0
      bottom: 0
      height: 34px
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)
      font-size: 12px
      color: $mainTextColor
      font-weight: bold
      letter-spacing: 0
      line-height: 34px
      text-shadow: 0 0 16px rgba(0,0,0,0.60)
      @include ellipsis
      ::before
        content: ' '
        display: block
        width: 4px
        height: 8px
        position: absolute
        background: #FF4343
        left: 0px
        bottom: 13px
        z-index: 1
      span
        padding-left: 12px
  .title
    margin-top: 14px
    font-size: 14px
    line-height: 120%
    color: $mainTextColor
    font-weight: bold
    @include ellipsis
.video-card-wrap:hover
  .title
    color: $mainColor
</style>
